import { render, staticRenderFns } from "./ContactSelectOption.vue?vue&type=template&id=488d7c20&scoped=true"
import script from "./ContactSelectOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSelectOption.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d7c20",
  null
  
)

export default component.exports